/**
 * Stub de pruebas para ApiMarcajes (re-exporta desde services para uso en ApiTesterComponent).
 * Las funciones de prueba delegan en ApiMarcajes cuando existan.
 */
import * as ApiMarcajes from '../services/ApiMarcajes';

export const probarObtenerTag = async (codPersona, empresa) => {
  try {
    if (ApiMarcajes.obtenerTagPersona) {
      return await ApiMarcajes.obtenerTagPersona(codPersona, empresa);
    }
    return { tag: '', error: 'obtenerTagPersona no disponible' };
  } catch (e) {
    return { tag: '', error: e?.message || String(e) };
  }
};

export const probarObtenerIdentificadores = async (localizacion) => {
  try {
    if (ApiMarcajes.extraerDatosLocalizacion) {
      return ApiMarcajes.extraerDatosLocalizacion(localizacion);
    }
    return { idReg: '', serviceTag: '', error: 'extraerDatosLocalizacion no disponible' };
  } catch (e) {
    return { idReg: '', serviceTag: '', error: e?.message || String(e) };
  }
};

export const probarExtraccionLocalizacion = async (localizacion) => {
  try {
    if (ApiMarcajes.extraerDatosLocalizacion) {
      const datos = ApiMarcajes.extraerDatosLocalizacion(localizacion);
      return { ...datos, localizacion };
    }
    return { partes: [], localizacion };
  } catch (e) {
    return { partes: [], error: e?.message || String(e) };
  }
};

export const probarBuscarServicio = async (localizacion) => {
  try {
    if (ApiMarcajes.buscarServicioFreematica && ApiMarcajes.extraerDatosLocalizacion) {
      const datos = ApiMarcajes.extraerDatosLocalizacion(localizacion);
      if (datos) {
        return await ApiMarcajes.buscarServicioFreematica(
          datos.empresa,
          datos.delegacion,
          datos.contrato,
          datos.servicio
        );
      }
    }
    return { idReg: '', serviceTag: '', error: 'buscarServicioFreematica no disponible' };
  } catch (e) {
    return { error: e?.message || String(e) };
  }
};

export const probarCrearMarcaje = async () => {
  return { ok: false, message: 'Usar probarCrearMarcajeTurno con fecha y horas' };
};

export const probarCrearMarcajeTurno = async (servicioInfo, tag, fecha, horaEntrada, horaSalida) => {
  try {
    if (ApiMarcajes.crearMarcajeTurno) {
      return await ApiMarcajes.crearMarcajeTurno(
        servicioInfo,
        tag,
        fecha,
        horaEntrada,
        horaSalida,
        'Prueba desde ApiTester'
      );
    }
    return { ok: false, message: 'crearMarcajeTurno no disponible' };
  } catch (e) {
    return { ok: false, error: e?.message || String(e) };
  }
};

export const ejecutarFlujoCompleto = async () => {
  return { ok: false, message: 'Flujo completo no implementado en stub' };
};
